<script setup>
import { numberWithCommas } from '@/helper';
import { swalError } from '@/helper';
import { get_count } from '@/services/option';
import { onMounted, ref } from 'vue';


const isLoading = ref(true)
const count = ref(0)
onMounted(async()=>{
  let response = await get_count('child')
  if (response.error){
    swalError(response.result.error)
  }else{
    count.value = response.result
  }
  isLoading.value = false
})

</script>

<template>
  <div class="card bg-light-success">
    <div class="card-body d-flex align-items-center">
      <div class="rounded-circle bg-light-success p-4">
        <vue-feather type="users" size="2rem"></vue-feather>
      </div>
      <div class="ms-3 text-dar">
        <h1 v-if="isLoading" class="placeholder-glow">
          <span class="placeholder col-6 rounded-2"></span>
        </h1>
        <h3 v-else class="mb-0">{{ numberWithCommas(count) }}</h3>
        <p>Registered Child</p>
      </div>
    </div>
  </div>
</template>

  